export default __webpack_public_path__ + "static/media/google.11e6d7c8.svg";